import beaRive from "./bea.riv";
import eddyRive from "./eddy.riv";
import falstaffRive from "./falstaff.riv";
import juniorRive from "./junior.riv";
import lilyRive from "./lily.riv";
import linRive from "./lin.riv";
import lucyRive from "./lucy.riv";
import oscarRive from "./oscar.riv";
import vikramRive from "./vikram.riv";
import zariRive from "./zari.riv";

export const defaultRiveRig = juniorRive;

export const CharactersToRigsMapping: Record<string, string> = {
  bea: beaRive,
  eddy: eddyRive,
  falstaff: falstaffRive,
  junior: juniorRive,
  lily: lilyRive,
  lin: linRive,
  lucy: lucyRive,
  oscar: oscarRive,
  vikram: vikramRive,
  zari: zariRive,
} as const;

export const characters = Object.keys(CharactersToRigsMapping);
